import styled from "styled-components";

export const Container = styled.section`
  padding-top: 120px;
  h2 {
    margin: 0px auto 50px;
    text-align: center;
  }
  .roadmap-line__step {
    position: relative;
    margin-top: 20px;
    h3 {
      max-width: 75%;
      width: unset;
      font-size: 40px;
      margin: -20px 0 0px 30px;
      padding: 10px 0 3px 40px;
      position: relative;
      color: white;
      z-index: 1;
      &::before {
        position: absolute;
        content: "";
        inset: 0px;
        background: url("data:image/png;base64,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")
          center center / 100% 100% no-repeat;
        filter: invert(0%);
        z-index: -1;
      }
    }
  }
  ul {
    margin: 30px 0 50px 0;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    li {
    }
  }
  .dc-list {
    position: relative;
    display: flex;
    align-items: center;
    &__icon {
      min-width: 30px;
      height: 30px;
      /* border-radius: 50%; */
      border: 3px solid rgb(0, 0, 0);
      display: flex;
      align-items: center;
      place-content: center;
      padding: 4px;
      position: absolute;
      left: 0px;
      top: 2px;
      span {
        display: flex;
        width: 100%;
        /* border-radius: 50%; */
        height: 100%;
        background: rgb(0, 0, 0);
      }
    }
    p {
      padding-left: 50px;
      min-height: 33px;
      opacity: 1;
      font-weight: bold;
      margin: 0;
    }
  }

  /* @media screen and (max-width: 570px) {
    .roadmap-line__step {
      height: unset !important;
      .roadmap-card {
        position: relative !important;
        width: 95% !important;
        margin: 75px auto 0 auto !important;
      }
      .card-up {
        bottom: unset;
        top: 0;
        &::before {
          position: absolute;
          left: 50%;
          top: -70px;
          content: "";
          height: 70px;
          width: 2px;
          border-radius: 50%;
          background: gray;
          z-index: 1;
        }
      }
      .card-down {
        top: 0;
      }
      .roadmap-timeline {
        top: 0 !important;
        margin-top: 10px;
      }
    }
  } */
`;
